module.exports = __webpack_public_path__ + "static/img/service.92887bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/service.jpg
// module id = XEwL
// module chunks = 0